//
// Generated class APPCC_Task
//

/// <reference path="APPCC_Task_ManagedObject.ts" />

class APPCC_Task extends APPCC_Task_ManagedObject
{

}
